import { useSelector, shallowEqual } from 'react-redux';

import {
  selectGasQuote,
  selectElectricityQuote,
  selectProductAnnualAmount,
  selectProductName,
  selectProductFeatures,
  selectTariffEndsOn,
  selectPriceGuranteedUntil,
  selectTariffType,
  selectSpecifics,
  selectMonthlyAmount,
  selectElectricityTariffCode,
  selectGasTariffCode,
  selectTOUDefinition,
  selectCurrentProduct
} from 'state/quote/quote-slice';
import { selectSlice as selectConsumption } from 'state/consumption/consumption-slice';
import { useTariffType } from 'components/direct-sales/quote/hooks/useTariffType';

export const useCurrentProduct = () => {
  const product = useSelector(selectCurrentProduct, shallowEqual);
  const { isFixed, isEV } = useTariffType(product);
  const gasQuote = useSelector(selectGasQuote, shallowEqual);
  const electricityQuote = useSelector(selectElectricityQuote, shallowEqual);
  const annualAmount = useSelector(selectProductAnnualAmount, shallowEqual);
  const monthlyAmount = useSelector(selectMonthlyAmount, shallowEqual);

  const productName = useSelector(selectProductName, shallowEqual);
  const features = useSelector(selectProductFeatures, shallowEqual);
  const specifics = useSelector(selectSpecifics, shallowEqual);
  const tariffEndsOn = useSelector(selectTariffEndsOn, shallowEqual);
  const { electric: electricityConsumption, gas: gasComsumption } = useSelector(
    selectConsumption,
    shallowEqual
  );
  const priceGuaranteedUntil = useSelector(
    selectPriceGuranteedUntil,
    shallowEqual
  );
  const electricityTariffCode = useSelector(
    selectElectricityTariffCode,
    shallowEqual
  );
  const gasTariffCode = useSelector(selectGasTariffCode, shallowEqual);
  const tariffType = useSelector(selectTariffType, shallowEqual);
  const touDefinition = useSelector(selectTOUDefinition);
  const isTOU = !!touDefinition;
  const code = product?.code || '';
  return {
    code,
    gasQuote,
    electricityQuote,
    annualAmount,
    monthlyAmount,
    productName,
    specifics,
    features,
    tariffEndsOn,
    priceGuaranteedUntil,
    tariffType,
    electricityConsumption,
    gasComsumption,
    electricityTariffCode,
    gasTariffCode,
    isFixed,
    isEV,
    isTOU
  };
};
